import React, { useEffect, useState } from 'react'
import { Statistic, Icon, Grid, Container, Image, Segment, Dimmer, Loader } from 'semantic-ui-react'
import Navbar from "../misc/Navbar";

function Home() {
    return (
        <Container text>
            <Grid stackable columns={2}>
                <Grid.Row>
                    <Grid.Column textAlign='center'>
                        <Segment color='blue'>
                            А тут ничего нет. Зачем пришел? Тест длины текста
                        </Segment>
                    </Grid.Column>
                    <Grid.Column textAlign='center'>
                        <Segment color='blue'>
                            А тут ничего нет. Зачем пришел? Тест длины текста
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    )
}

export default Home